/**
 * The field label and its required / optional marker.
 *
 * The label is a flex row so the marker sits at the end of the name rather than
 * wrapping under it — a marker on its own line reads as a second label.
 *
 * The marker is deliberately NOT colour-only. "Required" and "Optional" are
 * different WORDS, so the distinction survives greyscale, a colour-blind user
 * and a screen reader. The colour is a reinforcement, never the signal.
 */
export const styles = {
  label: 'flex flex-wrap items-baseline gap-x-2 gap-y-0.5 text-sm font-medium text-content',
  text: 'min-w-0',
  marker: 'text-2xs font-normal tracking-wide uppercase',
  /** Required reads as a demand, so it takes the caution tone rather than the error tone. */
  required: 'text-caution',
  /** Optional is reassurance, so it stays quiet. */
  optional: 'text-content-subtle',
  visuallyHidden: 'sr-only',
} as const;
